export function total (arr) {
  let total = [0, 0, 0, 0, 0, 0, 0, 0, 0]
  for (let index in arr) {
    if (Array.isArray(arr[index])) {
      for (let index1 in arr[index]) {
        total[index] += arr[index][index1] * 100
      }
    } else {
      total[0] += arr[index] * 100
    }
  }
  for (let index in total) {
    total[index] = '￥' + parseFloat(total[index] / 100).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    // if (total[index] !== 0) {
    //   total[index] = '￥' + parseFloat(total[index] / 100).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    // } else {
    //   total[index] = '￥' + parseFloat(total[index] / 100).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    // }
  }
  return total
}



// WEBPACK FOOTER //
// ./src/utils/totals.js